<form [formGroup]="learnsuccesscontrolForm" (ngSubmit)="learningDialogSubmit()">
  <div
    class="p-field required-field"
    [ngClass]="{
      'p-invalid':
        learnsuccesscontrolForm.get('title')?.invalid &&
        (learnsuccesscontrolForm.get('title')?.touched ||
          learnsuccesscontrolForm.get('title')?.dirty)
    }"
  >
    <p-floatLabel variant="in">
      <input pInputText id="title" type="text" formControlName="title" />
      <label for="title">Titel*</label>
    </p-floatLabel>
  </div>

  <div
    *ngIf="!selectedUser"
    class="form-group required-field"
    [ngClass]="{
      'p-invalid':
        learnsuccesscontrolForm.get('courseId')?.invalid &&
        (learnsuccesscontrolForm.get('courseId')?.touched ||
          learnsuccesscontrolForm.get('courseId')?.dirty)
    }"
  >
    <p-floatLabel variant="in">
      <p-dropdown
        [options]="availableCourses"
        name="courseId"
        id="courseId"
        optionLabel="courseName"
        optionValue="courseId"
        [showClear]="true"
        (onChange)="onCourseSelected($event.value)"
        formControlName="courseId"
        [filter]="true"
        filterBy="courseName"
      >
      </p-dropdown>
      <label>Kurs*</label>
    </p-floatLabel>
  </div>

  <div
    *ngIf="!selectedUser"
    class="form-group required-field"
    [ngClass]="{
      'p-invalid':
        learnsuccesscontrolForm.get('participantId')?.invalid &&
        (learnsuccesscontrolForm.get('participantId')?.touched ||
          learnsuccesscontrolForm.get('participantId')?.dirty)
    }"
  >
    <p-floatLabel variant="in">
      <p-dropdown
        [options]="availableParticipants"
        name="participantId"
        id="participantId"
        optionLabel="fullName"
        optionValue="userId"
        [showClear]="true"
        formControlName="participantId"
        [filter]="true"
        filterBy="fullName"
      >
      </p-dropdown>
      <label>
        {{
          learnsuccesscontrolForm.get("course")?.value === -1
            ? "Interessent:in*"
            : "Teilnehmer:innen*"
        }}
      </label>

      <p
        *ngIf="
          learnsuccesscontrolForm.get('courseId')?.value !== null &&
          availableParticipants.length === 0
        "
        style="margin-top: 5px; color: red; font-style: italic"
      >
        {{
          learnsuccesscontrolForm.get("courseId")?.value === -1
            ? "Keine Interessent:innen gefunden."
            : "Keine Teilnehmer für diesen Kurs gefunden."
        }}
      </p>
    </p-floatLabel>
  </div>

  <div class="p-fluid p-formgrid p-grid">
    <div
      class="p-field p-col-6 required-field"
      [ngClass]="{
        'p-invalid':
          learnsuccesscontrolForm.get('gesamtnote')?.invalid &&
          (learnsuccesscontrolForm.get('gesamtnote')?.touched ||
            learnsuccesscontrolForm.get('gesamtnote')?.dirty)
      }"
    >
      <p-floatLabel>
        <p-inputNumber
          id="gesamtnote"
          formControlName="gesamtnote"
          mode="decimal"
          [min]="1"
          [max]="6"
          [step]="0.1"
          [showButtons]="true"
          [style]="{ width: '100%' }"
        ></p-inputNumber>
        <label for="gesamtnote">Gesamtnote*</label>
      </p-floatLabel>

      <p class="info-text" style="margin-top: 0.5rem">
        Min: 1, Max: 6, Schrittweite: 0.1
      </p>
    </div>

    <div
      class="p-field p-col-6 required-field"
      [ngClass]="{
        'p-invalid':
          learnsuccesscontrolForm.get('gesamtpunkte')?.invalid &&
          (learnsuccesscontrolForm.get('gesamtpunkte')?.touched ||
            learnsuccesscontrolForm.get('gesamtpunkte')?.dirty)
      }"
    >
      <p-floatLabel>
        <p-inputNumber
          id="gesamtpunkte"
          formControlName="gesamtpunkte"
          mode="decimal"
          [showButtons]="true"
          [step]="0.1"
          [style]="{ width: '100%' }"
        ></p-inputNumber>
        <label for="gesamtpunkte">Gesamtpunkte*</label>
      </p-floatLabel>

      <p class="info-text" style="margin-top: 0.5rem">
        Kein bestimmter Min/Max, Schrittweite: 0.1
      </p>
    </div>
  </div>

  <!-- #region FILE DROP COMPONENT -->

  <app-filedrop
    bucketname="notes"
    (fileUploadStarted)="onFileUploadStarted()"
    (fileUploadCompleted)="onFilesUploaded($event)"
  >
  </app-filedrop>

  <!-- #endregion -->

  <p>(* Pflichtfelder)</p>

  <div class="form-buttons">
    <button
      pButton
      label="Speichern"
      title="Speichern"
      icon="pi pi-save"
      type="submit"
      class="p-button-success"
      [disabled]="!learnsuccesscontrolForm.valid || isSubmitting"
    ></button>
    <button
      pButton
      title="Abbrechen"
      type="button"
      label="Abbrechen"
      icon="pi pi-times"
      class="p-button-secondary"
      (click)="closeDialog()"
    ></button>
  </div>
</form>
